import { z } from "zod";

const recurringSchema = z.object({
  firstBillingDate: z.date(),
  iterations: z.number().int().min(1),
  billingDay: z.number().int().min(1).max(31),
  candidateAmountCents: z
    .number()
    .int()
    .min(1, { message: "Candidate fee is required" })
    .nullable()
    .refine((v) => v !== null, { message: "Candidate fee is required" }),
  platformFeeCents: z
    .number()
    .int()
    .min(1, { message: "Venturous fee is required" })
    .nullable()
    .refine((v) => v !== null, { message: "Venturous fee is required" }),
});

const milestoneTerms = z.object({
  milestoneLabel: z
    .string()
    .min(1, "A brief description of the milestone is required"),
  candidateAmountCents: z
    .number()
    .int()
    .min(1, { message: "Candidate fee is required" })
    .nullable()
    .refine((v) => v !== null, { message: "Candidate fee is required" }),
  platformFeeCents: z
    .number()
    .int()
    .min(1, { message: "Venturous fee is required" })
    .nullable()
    .refine((v) => v !== null, { message: "Venturous fee is required" }),
});

const milestoneSchema = z.object({
  firstBillingDate: z.date(),
  terms: z.array(milestoneTerms).min(1),
});

type RecurringSchema = z.infer<typeof recurringSchema>;
type MilestoneSchema = z.infer<typeof milestoneSchema>;

export {
  milestoneSchema,
  recurringSchema,
  type MilestoneSchema,
  type RecurringSchema,
};
